














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HowToCard extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: "" }) private logoUrl!: string;
  @Prop({ default: "" }) private description!: string;
}
